import {Injectable} from '@angular/core';
import {HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {RondeivuHttpClient} from "../../../../handlers";
import {iMandateRequest, iMandateResponse} from "../../models";
import {Observable} from "rxjs";
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from 'src/app/modules/shared/services';
import { MandateModalComponent } from '../../components';
import { toggleLoading } from 'src/app/modules/redux';
import { ModalSize } from 'src/app/modules/shared/services/util/util.service';
import { DataService } from 'src/app/services/data/data.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MandateService {

  private readonly MOCK_URL = environment.rondeivu_api_mock + '/mandates';

  private readonly BASE_URL = environment.rondeivu_api;
  private readonly FRAGMENT = '/mandates';

  constructor(
    private http: RondeivuHttpClient,
    private dialog: MatDialog,
    private util: UtilService,
    private dataService: DataService,
    private router: Router
  ) {

  }
  
  
  /**
   * Mandate modal
   */
  openMandateModal() {
    this.dialog.open(MandateModalComponent, {
      height: 'auto',
      backdropClass: "black-out-modal",
      width: this.util.getModalWidth(ModalSize.LARGE),
      disableClose: false
    })
    .afterClosed().subscribe((result: any) => {
      if (!!result) {
        this.addMandate(result).subscribe({
          next: (res: any) => {

            this.router.navigate(['/', this.dataService.getBuSlug(), 'deals']).then(() => {
            });
          }, error: err => {
          }
        });
      }
    });
  }

  addMandate(mandate: iMandateRequest) {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const req = JSON.stringify(mandate);
    // console.log(req);
    return this.http.post(this.BASE_URL + this.FRAGMENT, mandate, {headers: httpHeaders});
  }

  getMandates(): Observable<iMandateResponse[]> {
    return this.http.get<iMandateResponse[]>(this.BASE_URL + this.FRAGMENT);
  }

  getMandate(id: string): Observable<any> {
    return this.http.get(this.BASE_URL + this.FRAGMENT + '/' + id);
  }

  updateMandate(mandate:any): Observable<any> {
    return this.http.put(this.BASE_URL + this.FRAGMENT + '/' + mandate.id, mandate);
  }

  deleteMandate(id: string): Observable<any> {
    return this.http.delete(this.BASE_URL + this.FRAGMENT + '/' + id);
  }
}
